module.exports = __webpack_public_path__ + "img/xz_w_icon.35b2c4e6.png";